import __request__ from "routing/request";
export function getAll(requestOptions) {
  return __request__("GET", "/system/pipelines/pipeline", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createFromParser(pipeline, requestOptions) {
  return __request__("POST", "/system/pipelines/pipeline", pipeline, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/pipelines/pipeline/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function parse(pipeline, requestOptions) {
  return __request__("POST", "/system/pipelines/pipeline/parse", pipeline, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function routing(body, requestOptions) {
  return __request__("PUT", "/system/pipelines/pipeline/routing", body, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDeprecatedFunctionsForRule(id, requestOptions) {
  return __request__("GET", `/system/pipelines/pipeline/rule/${id}/deprecated_functions`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(id, requestOptions) {
  return __request__("GET", `/system/pipelines/pipeline/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(pipeline, id, requestOptions) {
  return __request__("PUT", `/system/pipelines/pipeline/${id}`, pipeline, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/system/pipelines/pipeline/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getRulesMetadata(id, requestOptions) {
  return __request__("GET", `/system/pipelines/pipeline/${id}/meta/rules`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
